// Brand & content assets (logo + user-provided photos)
export const LOGO = "/logo-island-camps.png"; // cream cursive on transparent
export const SUN_EMBOSS =
  "https://customer-assets.emergentagent.com/job_camps-summer-booking/artifacts/23wagda8_WhatsApp%20Image%202026-06-17%20at%2008.17.05.jpeg";

// User photos
// NOTE: previous "mermaid" photo removed at client request — replaced with a royalty-free beach/nature image.
export const PHOTO_MERMAID =
  "https://images.unsplash.com/photo-1773947502838-07725a75a265?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const PHOTO_PIRATE_SHIP =
  "https://customer-assets.emergentagent.com/job_camps-summer-booking/artifacts/xzf0cdqf_WhatsApp%20Image%202026-06-15%20at%2010.20.56.jpeg";
export const PHOTO_NICHE =
  "https://customer-assets.emergentagent.com/job_camps-summer-booking/artifacts/ar242whx_WhatsApp%20Image%202026-06-15%20at%2014.09.59.jpeg";
export const PHOTO_LEAVES =
  "https://customer-assets.emergentagent.com/job_camps-summer-booking/artifacts/yw1zkdbg_WhatsApp%20Image%202026-06-15%20at%2010.21.24.jpeg";

export const HERO_PHOTOS = [PHOTO_MERMAID, PHOTO_PIRATE_SHIP, PHOTO_NICHE];
export const CARNET_PHOTOS = [
  { src: PHOTO_PIRATE_SHIP, tag: "pirate" },
  { src: PHOTO_MERMAID, tag: "sirene" },
  { src: PHOTO_NICHE, tag: "enquete" },
  { src: PHOTO_LEAVES, tag: "nature" },
];

// Saint-Barth tropical ambiance (stock)
export const IMG_LAGOON =
  "https://images.pexels.com/photos/10854894/pexels-photo-10854894.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";
export const IMG_PALM_BEACH =
  "https://images.pexels.com/photos/33836963/pexels-photo-33836963.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";
export const IMG_CRAFT =
  "https://images.unsplash.com/photo-1560831340-b9679dc9e9f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const IMG_NATURE_KIDS =
  "https://images.unsplash.com/photo-1779233106352-0192a31fe932?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

// Activity card images
export const ACTIVITY_IMAGES = {
  vacances: PHOTO_PIRATE_SHIP,
  periscolaire: IMG_CRAFT,
  ateliers: PHOTO_NICHE,
  nature: IMG_NATURE_KIDS,
};
